import React, { memo } from 'react';

import { useNavigation } from '@react-navigation/native';

import { CloseIcon } from '@/assets/icons/close';
import { SCREEN_NAV_BAR_HEIGHT, SHEET_NAV_BAR_TOP_SPACING } from '@/components/ScreenNavBar';
import { Box, Row, TouchableBox } from '@/components/lib/components';
import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';

type HeaderProps = {
    balanceButton: React.ReactNode;
    rightItem?: React.ReactNode;
    isSubmitting?: boolean;
    onRightItemPress?: () => void;
};
const ITEM_WIDTH = 48;

export const CheckoutHeader = memo(({ balanceButton, rightItem, isSubmitting, onRightItemPress }: HeaderProps) => {
    const navigation = useNavigation();

    const onClosePress = () => {
        GASbkEvents.clickBetSlipCloseButton();
        navigation.goBack();
    };

    return (
        <Row
            paddingHorizontal="s4"
            alignItems="center"
            justifyContent="space-between"
            height={SCREEN_NAV_BAR_HEIGHT}
            style={{ marginTop: SHEET_NAV_BAR_TOP_SPACING }}
        >
            <TouchableBox onPress={onClosePress} padding="s12" disabled={isSubmitting} width={ITEM_WIDTH}>
                <CloseIcon />
            </TouchableBox>
            {balanceButton}
            {rightItem ? (
                <TouchableBox
                    alignItems="flex-end"
                    width={ITEM_WIDTH}
                    hitSlop={20}
                    disabled={isSubmitting}
                    // add additional padding only if the width of the page is bigger then the maximum width we have on web
                    onPress={onRightItemPress}
                >
                    {rightItem}
                </TouchableBox>
            ) : (
                <Box width={ITEM_WIDTH} />
            )}
        </Row>
    );
});
